<script>
    import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import * as m from '@app/paraglide/messages.js';
import flexbox from '@cclib/dict/flexbox.js';
  /** @type {{eventIndex: any}} */
  let { event, eventIndex } = $props();
</script>

<div id="transcriptEditorPreview-{eventIndex}"
  role="region"
  aria-label={m.event_transcript_preview_aria_label({eventIndex})}
  class="text-white bg-secondary text-{flexbox.alignmentMap[event.alignment]} p-2 EditorPreviewText rounded" style="font-family: '{eventGroupState[projectState.selected]?.fontFamily || 'plexMono'}' !important; font-size: {eventGroupState[projectState.selected]?.fontSize || 18}px; line-height: 102%; direction: {eventGroupState[projectState.selected].rtl ? 'rtl' : 'ltr'};">
    {@html event.text}
</div>
<style lang="css">
.EditorPreviewText {
    height: 160px;
    overflow-y: auto;
    overflow-x: hidden;
}    
</style>